'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useState } from 'react';
import { extractProps } from '@radix-ui/themes/helpers';
import { twMerge } from 'tailwind-merge';
import { faAngleDown, faAngleUp } from '@fortawesome/pro-regular-svg-icons';
import { Box, Flex } from '../layout/index.js';
import { IconButton } from '../icon-button/index.js';
import { Icon } from '../icon/index.js';
import { Tooltip } from '../tooltip/index.js';
import { Button } from '../button/index.js';
import { useSideNavigation } from './side-navigation.store.js';
import { sideNavigationGroupPropDefs } from './side-navigation.props.js';
const SideNavigationGroup = forwardRef((props, forwardedRef) => {
    const { className, children, icon, label, direction, pl, gapY, color, defaultOpen } = extractProps(props, sideNavigationGroupPropDefs);
    const { expanded: expandedSideNavigation } = useSideNavigation();
    const [expanded, setExpanded] = useState(Boolean(defaultOpen));
    if (expandedSideNavigation) {
        return (_jsxs(Flex, { direction: direction, gapY: gapY, className: "rt-SideNavigationGroup", children: [_jsx(Flex, { align: "center", width: '100%', justify: 'start', asChild: true, children: _jsxs(Button, { className: className, ref: forwardedRef, color: color, variant: "soft", onClick: () => {
                            setExpanded(!expanded);
                        }, children: [icon, label, _jsx(Icon, { className: "ms-auto", color: color, icon: expanded ? faAngleUp : faAngleDown, label: "Sub menu" })] }) }), expanded ? (_jsx(Flex, { direction: direction, gapY: gapY, pl: pl, children: children })) : null] }));
    }
    if (icon) {
        return (_jsx(Tooltip, { content: label, side: "right", className: "rt-SideNavigationGroup", children: _jsx(IconButton, { ref: forwardedRef, className: className, color: color, variant: "soft", children: icon }) }));
    }
    return (_jsx(Box, { className: twMerge('rt-SideNavigationGroup overflow-hidden invisible', className), children: label }));
});
SideNavigationGroup.displayName = 'SideNavigation.Group';
export { SideNavigationGroup };
//# sourceMappingURL=side-navigation-group.js.map